module.exports = __webpack_public_path__ + "img/background_principal_pc.e9781ccd.webp";